import { UserInterface, UserData } from "./../interface/user.interface";
import { ResPagingDto } from "../interface/share.interface";
import { GET, PUT, POST } from "./request";

export const getUsers = (params: UserInterface) => {
  return GET<ResPagingDto<UserInterface[]>>("/user", params);
};

export const getUserProfile = () => {
  return GET<UserData>("/user/profile");
};

export const updateUser = (data: Partial<UserInterface>) => {
  const payload = {
    name: data.name,
    email: data.email,
  };
  return PUT<UserInterface>("/user", payload);
};

export const updateProfile = (data: Partial<UserInterface>) => {
  return PUT<UserInterface>("/user/updateProfile", data);
};

export const changePassword = (data: Partial<UserInterface>) => {
  return PUT<UserInterface>("/user/change-password", data);
};

export const resetUserPassword = (userId: string) => {
  return POST<{ message: string }>("/user/reset-password", { userId });
};

export const changeStatus = (id: string, status: string) => {
  return PUT(`/user/changeStatus/${id}`, { status });
};
export const configUser = {
  navigate: "/user",
  urlInfo: "",
  urlEdit: "user",
  urlAdd: "user",
  urlGetInfo: "user",
  urlDelete: "user",
};
